module.exports = __webpack_public_path__ + "static/media/threeTone.f981ce1c.jpg";